import React from "react";
import "./Igtv.css";
const Igtv = () => {
  return (
    <div>
      <h1 className="igtv">no igtv posts</h1>
    </div>
  );
};

export default Igtv;
